import { Tooltip } from 'flowbite-react';
import { FC, JSX, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

interface SitesStatusTooltipProps extends PropsWithChildren {
    status: string;
    icon: JSX.Element;
}

export const SitesStatusTooltip: FC<SitesStatusTooltipProps> = ({
    status,
    icon,
    children,
}) => {
    const { t } = useTranslation();

    const tooltipContent = (
        <div className="flex gap-2 items-center">
            <div className="w-6 h-6">{icon}</div>
            <span className="text-sm">
                {t(`overview:site_status_tooltip:${status}`)}
            </span>
        </div>
    );

    return (
        <Tooltip
            content={tooltipContent}
            style="light"
            className="w-72 z-(--z-tooltip) flex normal-case"
        >
            {children}
        </Tooltip>
    );
};
